module.exports = __webpack_public_path__ + "img/menu-more-active.43cc5641.svg";